/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Copy_Dialogue_Track_2Inputs */

const en_event_group_options_copy_dialogue_track_2 = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Dialogue From Track 2`)
};

const fr_event_group_options_copy_dialogue_track_2 = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier les dialogues de la piste 2`)
};

const de_event_group_options_copy_dialogue_track_2 = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialog von Spur 2 kopieren`)
};

const it_event_group_options_copy_dialogue_track_2 = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia il dialogo dalla traccia 2`)
};

const ru_event_group_options_copy_dialogue_track_2 = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать диалог со второй дорожки`)
};

const es_event_group_options_copy_dialogue_track_2 = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar diálogo de la pista 2`)
};

const zh_cn2_event_group_options_copy_dialogue_track_2 = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从音轨 2 复制对话`)
};

const ja_event_group_options_copy_dialogue_track_2 = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラック2からダイアログをコピー`)
};

const hi_event_group_options_copy_dialogue_track_2 = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक 2 से संवाद कॉपी करें`)
};

const pt_pt2_event_group_options_copy_dialogue_track_2 = /** @type {(inputs: Event_Group_Options_Copy_Dialogue_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar diálogo da faixa 2`)
};

/**
* | output |
* | --- |
* | "Copy Dialogue From Track 2" |
*
* @param {Event_Group_Options_Copy_Dialogue_Track_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_copy_dialogue_track_2 = /** @type {((inputs?: Event_Group_Options_Copy_Dialogue_Track_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Copy_Dialogue_Track_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_copy_dialogue_track_2(inputs)
	if (locale === "de") return de_event_group_options_copy_dialogue_track_2(inputs)
	if (locale === "it") return it_event_group_options_copy_dialogue_track_2(inputs)
	if (locale === "ru") return ru_event_group_options_copy_dialogue_track_2(inputs)
	if (locale === "es") return es_event_group_options_copy_dialogue_track_2(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_copy_dialogue_track_2(inputs)
	if (locale === "ja") return ja_event_group_options_copy_dialogue_track_2(inputs)
	if (locale === "hi") return hi_event_group_options_copy_dialogue_track_2(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_copy_dialogue_track_2(inputs)
	return en_event_group_options_copy_dialogue_track_2(inputs)
});